import { render, staticRenderFns } from "./GlobalPage.vue?vue&type=template&id=1152babf&scoped=true"
import script from "./GlobalPage.vue?vue&type=script&lang=js"
export * from "./GlobalPage.vue?vue&type=script&lang=js"
import style0 from "./GlobalPage.vue?vue&type=style&index=0&id=1152babf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152babf",
  null
  
)

export default component.exports